import * as moment from "moment";

export interface IPowerTimeMonth {
    daysInMonth: number;
    month: number;
    year: number;
    minutesAhead: number;
    dayEntries: IPowerTimeDay[];
}

export interface IPowerTimeDay {
    date?: string;
    number: number | string;
    timeEntries: ISlot[];

    availableTimes?: ISlot[];
}

export interface IPowerTimeEntry {
    dateTimeOffset: string;
    start: string;
    duration: number;
    name: string;
    description: string;
    appointmentId?: number;
    providerId?: number;
    providers: IIdNameItem[];
    locationId?: number;
    type: SlotType;
    isBooked: boolean;
}

export interface ISlot extends IPowerTimeEntry {
    id: string | number;
    hour: string;
    date?: moment.Moment;
}

export interface IIdNameItem {
    id: number;
    name: string;
}

export enum SlotType {
    Available = 1,
    Class = 2,
    Appointment = 3,
}

type TYear = number;
type TMonth = string | number;
export type Availability = Record<TYear, Record<TMonth, IPowerTimeDay[]>>;

export interface IDay {
    availability?: IDayPeriod;
    date: moment.Moment;
}

export interface IDayPeriod {
    morning: ISlot[] | boolean;
    afternoon: ISlot[] | boolean;
    evening: ISlot[] | boolean;
}
